// src/components/Banner.js
import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './banner.css'; // Assuming kebab-case now? Or keep banner.css
import logo from '../assets/images/logo.jpg';
import { useAuth } from '../context/AuthContext';
import useLocale from '../hooks/useLocale'; // Import hook

function Banner() {
    // 1. Get 't' function (and handleLanguageChange if needed, but not used here)
    const { t } = useLocale();
    const { isLoggedIn, user, logout } = useAuth();
    const navigate = useNavigate();

    // Dropdown state and refs remain the same
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const triggerRef = useRef(null);

    // handleLogout and handleNavigate remain the same
    const handleLogout = () => {
        logout();
        setIsDropdownOpen(false);
    };

    const handleNavigate = (path) => {
        setIsDropdownOpen(false);
        navigate(path);
    };

    // useEffect for click outside remains the same
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isDropdownOpen &&
                dropdownRef.current && !dropdownRef.current.contains(event.target) &&
                triggerRef.current && !triggerRef.current.contains(event.target))
            {
                setIsDropdownOpen(false);
            }
        };
        if (isDropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isDropdownOpen]);

    return (
        <div className="banner-container">
            <div id="logo" className="logo-container">
                <img
                    src={logo}
                    // 2. Use t() for alt text
                    alt={t('banner_logo_alt', 'AstronomyShare.com Logo')}
                    className="logo-image"
                />
                <div className="title-welcome-block">
                    <span className="site-title">
                        {/* 2. Use t() for site title */}
                        {t('common_site_title', 'AstronomyShare.com')} {/* Using a common key */}
                    </span>
                </div>
            </div>
            <nav>
                <ul>
                    {isLoggedIn && user ? (
                        // --- Menu items when logged IN ---
                        <>
                            {/* 2. Use t() and standardized nav keys */}
                            <li><Link to="/home" className="app-link">{t('nav_home', 'Home')}</Link></li>
                            <li><Link to="/browse" className="app-link">{t('nav_browse', 'Browse')}</Link></li>
                            <li><Link to="/upload" className="app-link">{t('nav_upload', 'Upload')}</Link></li>

                            <li className="user-menu-container" ref={dropdownRef}>
                                <button
                                    ref={triggerRef}
                                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                    className="user-menu-trigger"
                                    aria-haspopup="true"
                                    aria-expanded={isDropdownOpen}
                                >
                                    {user.username} ▼
                                </button>
                                {isDropdownOpen && (
                                    <ul className="user-dropdown-menu">
                                        <li>
                                            <button onClick={() => handleNavigate('/settings')} className="dropdown-item">
                                                {/* 2. Use t() and standardized nav key */}
                                                {t('nav_settings', 'User Settings')}
                                            </button>
                                        </li>
                                        <li>
                                            <button onClick={handleLogout} className="dropdown-item logout-item">
                                                 {/* 2. Use t() and standardized nav key */}
                                                {t('nav_logout', 'Log Out')}
                                            </button>
                                        </li>
                                    </ul>
                                )}
                            </li>
                        </>
                    ) : (
                        // --- Menu items when logged OUT ---
                        <>
                             {/* 2. Use t() and standardized nav keys */}
                            <li><Link to="/" className="app-link">{t('nav_home', 'Home')}</Link></li>
                            <li><Link to="/tou" className="app-link">{t('nav_terms', 'Terms of Use')}</Link></li>
                            <li><Link to="/pp" className="app-link">{t('nav_privacy', 'Privacy Policy')}</Link></li>
                            <li><Link to="/register" className="app-link">{t('nav_register', 'Register')}</Link></li>
                            <li><Link to="/login" className="app-link">{t('nav_login', 'Login')}</Link></li>
                        </>
                    )}
                </ul>
            </nav>
        </div>
    );
}

export default Banner;